import { render, staticRenderFns } from "./ProductDetailMobile.vue?vue&type=template&id=10d9a154&scoped=true&"
import script from "./ProductDetailMobile.vue?vue&type=script&lang=js&"
export * from "./ProductDetailMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailMobile.vue?vue&type=style&index=0&id=10d9a154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9a154",
  null
  
)

export default component.exports